import { Collapse } from "antd";
import CollapseStyled from "../../../../../../../../../style/CollapseStyled";
import { useTranslation } from "react-i18next";
import { useSubjects } from "../../../../../../../../../hooks/useSubjects";
import { useEffect, useState } from "react";
import { SubjectHistory } from "../../../../../../../../../redux/apiSpecifications/apiSubjects";
import { useSubjectDetailsContext } from "../PolicySubjectDetailsContext";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { RefreshInTabWrapper } from "../../../../../../../../../style/DashbordWidgetWrappers";
import { IconLoading } from "../../../../../../../../../config/icons";
import EntityHistoryList from "../../../../../../../../Widgets/EntityHistoryList/EntityHistoryList";

const PolicySubjectTabHistory = () => {
  const { t } = useTranslation();

  const { getSubjectHistoryPromise } = useSubjects();
  const { subject, status } = useSubjectDetailsContext();

  const [history, setHistory] = useState<SubjectHistory[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<FetchBaseQueryError>();

  useEffect(() => {
    if (!subject?.id) return;

    setLoading(true);

    getSubjectHistoryPromise(subject.id)
      .then((data) => {
        setHistory(data as SubjectHistory[]);

        setLoading(false);
      })
      .catch((error) => {
        setError(error as FetchBaseQueryError);

        setLoading(false);
      });
  }, [subject?.id]);

  return (
    <>
      {loading && (
        <RefreshInTabWrapper
          className="positionLoading"
          // data-testid={testIds.loadingContainer}
        >
          <div className="box">{IconLoading}</div>
        </RefreshInTabWrapper>
      )}

      <CollapseStyled defaultActiveKey={["history"]}>
        <Collapse.Panel
          key={"history"}
          header={t("PANEL-HEADERS.subject-history")}
        >
          <EntityHistoryList historical={history} />
        </Collapse.Panel>
        {/* <pre>{JSON.stringify(history, null, 2)}</pre> */}
      </CollapseStyled>
    </>
  );
};
export default PolicySubjectTabHistory;
